export const accountState = {
    currentUser: null,
    wishlist: [],
};
